import './Login.scss';
import ZionLogo from 'assets/zion_logo.png';
import {useState, useEffect} from "react";
import api from "../../utils/api";
import LangDropdown from "../LangDropdown/LangDropdown";
import {FormattedMessage, useIntl} from "react-intl";
import {useCommonStore} from "../../hooks/useCommonStore";
import {useNavigate} from "react-router-dom";

const Login = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const {isSignIn, access} = useCommonStore();

  const [completionCode, setCompletionCode] = useState('');
  const [birthday, setBirthday] = useState('');

  useEffect(() => {
    if (isSignIn && access.authLevel) {
      navigate('/main');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await api.post(`/v1/auth/completions`, {completionCode, birthday})
    if (res.status === 200) window.location.href = '/login/callback';
    else window.location.href = `/login/callback/error?message=${res.message}`;
  }

  return (
    <div className='Login'>
      <div className='main-title'>
        <FormattedMessage id='@title'/>
      </div>
      <img className='logo-img' src={ZionLogo} alt='ZionLogo'/>
      <form className='inputs' onSubmit={handleSubmit}>
        <LangDropdown/>
        <div className='inputs-description'>
          <FormattedMessage id='@exam_login_guide'/>
        </div>
        <input
          placeholder={intl.formatMessage({id: '@exam_login_placeholder_1'})}
          type={'text'}
          value={completionCode}
          pattern='\d{0,10}'    // 0~10 자리의 숫자만 허용
          onChange={(e) => {
            if (e.target.validity.valid) {
              setCompletionCode(e.target.value);
            }
          }}
        />
        <input
          placeholder={intl.formatMessage({id: '@exam_login_placeholder_2'})}
          type={'text'}
          value={birthday}
          pattern='\d{0,8}'   // 0~8 자리의 숫자만 허용
          onChange={(e) => {
            if (e.target.validity.valid) {
              setBirthday(e.target.value);
            }
          }}
        />
        <button type={'submit'} className='student-login'>
          <FormattedMessage id='@exam_login_submit_btn'/>
        </button>
      </form>
    </div>
  );
}

export default Login;